var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioCheckedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8921 1.49643C12.5516 1.15576 12.1473 0.885523 11.7023 0.701148C11.2574 0.516773 10.7804 0.421875 10.2988 0.421875C9.81712 0.421875 9.34018 0.516773 8.89521 0.701148C8.45023 0.885523 8.04595 1.15576 7.70544 1.49643L6.99878 2.20309L6.29211 1.49643C5.60431 0.808631 4.67147 0.422232 3.69878 0.422232C2.72609 0.422232 1.79324 0.808631 1.10544 1.49643C0.417649 2.18422 0.03125 3.11707 0.03125 4.08976C0.03125 5.06245 0.417649 5.9953 1.10544 6.68309L1.81211 7.38976L6.99878 12.5764L12.1854 7.38976L12.8921 6.68309C13.2328 6.34259 13.503 5.9383 13.6874 5.49333C13.8718 5.04836 13.9667 4.57142 13.9667 4.08976C13.9667 3.6081 13.8718 3.13116 13.6874 2.68619C13.503 2.24122 13.2328 1.83693 12.8921 1.49643Z",
    fill: "#EF8B6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioCheckedIcon);
export default __webpack_public_path__ + "static/media/RadioCheckedIcon.c391ce49f60e09dc1d885e55deccebb3.svg";
export { ForwardRef as ReactComponent };